'use strict';

const _=require('pulsar-utils/dist-es6/_');
const ex=require('pulsar-utils/dist-es6/ex');
const LatLongLocation=require('pulsar-fatigue/dist-es6/domain/latLongLocation');
const GeocodedStatus=require('pulsar-driveplan/dist-es6/domain/geocodedStatus');
const GeocodedStatusTimeSeriesPoint=require('pulsar-driveplan/dist-es6/domain/geocodedStatusTimeSeriesPoint');
const HosStatusDurations=require('../../../dist-es6/client/dtos/hosStatusDurations');
const fdie=require('../../../dist-es6/client/extensions/fatigueDistributionIterableExtensions');
const DistributionParameters=require('../../../dist-es6/shared/domain/distributionParameters');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const EntityDictionary=require('pulsar-utils/dist-es6/domain/entityDictionary');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const DashboardPersonViewModel=require('../../../dist-es6/client/viewModels/dashboardPersonViewModel');
const FlightMonitorPersonViewModel=require('../../../dist-es6/client/viewModels/flightMonitorPersonViewModel');
const ForecastPersonViewModel=require('../../../dist-es6/client/viewModels/forecastPersonViewModel');
const FleetIncidentsPersonViewModel=require('../../../dist-es6/client/viewModels/fleetIncidentsPersonViewModel');
const FatigueTrendsPersonViewModel=require('../../../dist-es6/client/viewModels/fatigueTrendsPersonViewModel');
const GroupStatisticsViewModel=require('../../../dist-es6/client/viewModels/groupStatisticsViewModel');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const FlightViewModel=require('../../../dist-es6/client/viewModels/flightViewModel');
const DutyViewModel=require('../../../dist-es6/client/viewModels/dutyViewModel');
const TripViewModel=require('../../../dist-es6/client/viewModels/tripViewModel');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const CalendarRange=require('pulsar-utils/dist-es6/time/calendarRange');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');

const GroupDataSocketOptions={
timeoutInSeconds:300,
retryOptions:{
retries:5,
maxTimeout:30000},

throwOnUnexpectedError:!0};


const DefaultGroupViewModelBuilder=(...args)=>new GroupStatisticsViewModel(...args);let

StatisticalDisplayDataService=class StatisticalDisplayDataService extends BaseService{
constructor($state,socketService,groupsPopulationService,timeZoneService,organizationDefaultsService,dateService,fatigueMeterTypeContentProviderService){
super();

this._$state=$state;
this._socketService=socketService;
this._groupsPopulationService=groupsPopulationService;
this._timeZoneService=timeZoneService;
this._organizationDefaultsService=organizationDefaultsService;
this._dateService=dateService;
this._fatigueMeterTypeContentProviderService=fatigueMeterTypeContentProviderService;
}

async fetchDashboardData(){
const socketCommandName='GetDashboardDisplayData';

const rawDataInflator=rawDisplayData=>{
for(let person of rawDisplayData.persons){
person.lastKnownStatus.time=SocketResponse.safeDeserializeDate(person.lastKnownStatus.time);
person.estimatesAsOfTime=rawDisplayData.estimatesAsOfTime;
}
return rawDisplayData;
};

const groupViewModelBuilder=(...args)=>{

const gsvm=new GroupStatisticsViewModel(...args);
gsvm.maxFatigueForHeader=gsvm.maxLastKnownFatigue;
return gsvm;
};

const viewScheduleBuilder=this._getViewScheduleBuilderForCurrentTime('lastKnownStatus.time');
const rootPersonViewModelBuilder=personStats=>new DashboardPersonViewModel(personStats,viewScheduleBuilder(personStats));
const treePersonViewModelBuilder=rootPersonViewModel=>new DashboardPersonViewModel(rootPersonViewModel.statistics,rootPersonViewModel.viewSchedule);

return await this._fetchLatestGroupData(socketCommandName,void 0,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder);
}

async fetchFlightMonitorData(options={}){
const socketCommandName='GetFlightMonitorDisplayData';

const rawDataInflator=rawDisplayData=>{
for(let person of rawDisplayData.persons){
person.effectiveStatus.time=SocketResponse.safeDeserializeDate(person.effectiveStatus.time);
person.estimatesAsOfTime=rawDisplayData.estimatesAsOfTime;
_inflateSchedule(person.schedule);
}
return rawDisplayData;
};

const groupViewModelBuilder=(...args)=>{
const gsvm=new GroupStatisticsViewModel(...args);
gsvm.maxFatigueForHeader=gsvm.maxLastKnownFatigue;
return gsvm;
};

const viewScheduleBuilder=this._getViewScheduleBuilderForCurrentTime('currentStatus.time');
const rootPersonViewModelBuilder=personStats=>new FlightMonitorPersonViewModel(personStats,viewScheduleBuilder(personStats));
const treePersonViewModelBuilder=rootPersonViewModel=>new FlightMonitorPersonViewModel(rootPersonViewModel.statistics,rootPersonViewModel.viewSchedule);
return await this._fetchLatestGroupData(socketCommandName,options,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder);
}

async fetchForecastData(options={}){
const socketCommandName='GetForecastDisplayData';

const{alertsSource,visualNotificationType,intervalTypesWithThresholdStatus}=this._fatigueMeterTypeContentProviderService;

let currentTimeForForecast;
let visibleBounds;
const rawDataInflator=rawDisplayData=>{

currentTimeForForecast=SocketResponse.safeDeserializeDate(rawDisplayData.currentTimeForForecast);
visibleBounds=new TimeInterval(rawDisplayData.visibleBounds);

for(let person of rawDisplayData.persons){
if(_.exists(person.forecast)){
_inflateSchedule(person.forecast.schedule);
_inflateSchedule(person.forecast.scenario);
for(var i=person.forecast.scenario.fatigue.length-1;i>=0;i--){
person.forecast.scenario.fatigue[i].time=new Date(person.forecast.scenario.fatigue[i].time);
}
_inflateInPlace(person.forecast,'currentShiftHosStatusDurations',HosStatusDurations.fromJSON);
_inflateInPlace(person.forecast,'predictedWorkday',i=>new TimeInterval(i));

if(person.forecast.currentHosStatus){
const time=_.isDate(person.forecast.currentHosStatus.time)?person.forecast.currentHosStatus.time:new Date(person.forecast.currentHosStatus.time);
const status=GeocodedStatus.Statuses[person.forecast.currentHosStatus.value.status.name];
const{lat,long,description}=person.forecast.currentHosStatus.value.location;
const location=_.attempt(()=>new LatLongLocation(lat,long,description));

person.forecast.currentHosStatus=GeocodedStatusTimeSeriesPoint.create(time,status,!_.isError(location)?location:null);
}
}

if(_.exists(person,'effectiveStatus.time')&&!_.isDate(person.effectiveStatus.time)){
person.effectiveStatus.time=new Date(person.effectiveStatus.time);
}

if(_.exists(person,'lastKnownStatus.time')&&!_.isDate(person.lastKnownStatus.time)){
person.lastKnownStatus.time=new Date(person.lastKnownStatus.time);
}

_.assign(person,{
alertsSource,
visualNotificationType,
intervalTypesWithThresholdStatus,
visibleBounds,
currentTime:currentTimeForForecast,
estimatesAsOfTime:rawDisplayData.estimatesAsOfTime});

}
return rawDisplayData;
};

const groupViewModelBuilder=DefaultGroupViewModelBuilder;
const viewScheduleBuilder=this._getViewScheduleBuilderForCurrentTime('currentStatus.time');
const rootPersonViewModelBuilder=personStats=>new ForecastPersonViewModel(personStats,viewScheduleBuilder(personStats));
const treePersonViewModelBuilder=rootPersonViewModel=>new ForecastPersonViewModel(rootPersonViewModel.statistics,rootPersonViewModel.viewSchedule);

const results=await this._fetchLatestGroupData(socketCommandName,options,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder);

results.currentTimeForForecast=currentTimeForForecast;
results.visibleBounds=visibleBounds;

return results;
}

_getViewScheduleBuilderForCurrentTime(propertyPath){
const now=this._dateService.now();

const _getTime=_.exists(propertyPath)?
personData=>_.get(personData,propertyPath,now):
personData=>now;

const viewScheduleBuilder=personData=>this._getViewScheduleFunc({
id:personData.id,
employeeId:personData.employeeId,
interval:TimeInterval.fromPoint(_getTime(personData)||now),
timezone:personData.timezone});


return viewScheduleBuilder;
}

async _fetchLatestGroupData(socketCommandName,socketRequestBody,rawDataInflator,groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder){
let{body:rawDisplayData}=await this._socketService.sendAndWaitForResponse(socketCommandName,socketRequestBody,GroupDataSocketOptions);

return await this._buildViewModels({groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData,rawDataInflator});
}

_getFleetInsightPersonViewScheduleBuilderFor(calendarRange){
_.ensureInstanceOf(CalendarRange,calendarRange);

return personStats=>this._getViewScheduleFunc({
id:personStats.id,
employeeId:personStats.employeeId,
interval:calendarRange.asExpandedTimeInterval(personStats.timezone).expandToRoundTarget('week',personStats.timezone),
timezone:personStats.timezone});

}

async fetchFleetIncidentsDataFor({queryInterval}){

const{body:rawDisplayData}=await this._socketService.sendAndWaitForResponse('GetFleetIncidentsDisplayData',{queryInterval},{throwOnUnexpectedError:!0});

const incidentTypesByCode=_.keyBy(rawDisplayData.incidentTypes,'code');


const viewScheduleBuilder=personStats=>()=>void 0;

const groupViewModelBuilder=DefaultGroupViewModelBuilder;

const rootPersonViewModelBuilder=personStats=>{
const incidents=this._createIncidentViewModelsFor(personStats,incidentTypesByCode);
return new FleetIncidentsPersonViewModel(personStats,viewScheduleBuilder(personStats),incidents);
};

const treePersonViewModelBuilder=rootViewModel=>new FleetIncidentsPersonViewModel(rootViewModel.statistics,rootViewModel.viewSchedule,rootViewModel.incidents);

const results=await this._buildViewModels({groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData});
results.incidentTypes=rawDisplayData.incidentTypes;

return results;
}

async fetchFatigueTrendsDataFor(params){
let{calendarRange,requestedOrgStats,requestedGroupStats,requestedPersonalStats}=params;
_.ensureInstanceOf(Array,requestedOrgStats);
_.ensureInstanceOf(Array,requestedGroupStats);
_.ensureInstanceOf(Array,requestedPersonalStats);

const{body:rawDisplayData}=await this._socketService.sendAndWaitForResponse(
'GetFleetInsightDisplayData',{
calendarRange,
requestedOrgStats,
requestedGroupStats,
requestedPersonalStats},
{
throwOnUnexpectedError:!0});


const viewScheduleBuilder=this._getFleetInsightPersonViewScheduleBuilderFor(calendarRange);

const groupViewModelBuilder=(...args)=>{

const gsvm=new GroupStatisticsViewModel(...args);
gsvm.maxFatigueForHeader=gsvm.maxFatigueOnDuty;
gsvm.fatigueDistribution=fdie(gsvm.aggregatePersons.map(p=>p.statistics.fatigueDistribution)).aggregate(DistributionParameters.DefaultFatigueDistributionParameters);
return gsvm;
};

const rootPersonViewModelBuilder=personStats=>{
const personViewModel=new FatigueTrendsPersonViewModel(personStats,viewScheduleBuilder(personStats));
_updateFatigueDistributionMetaData(personViewModel.statistics.fatigueDistribution,personViewModel);
return personViewModel;
};

const treePersonViewModelBuilder=rootViewModel=>{
return new FatigueTrendsPersonViewModel(rootViewModel.statistics,rootViewModel.viewSchedule);
};

return await this._buildViewModels({groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData});
}

async _buildViewModels({groupViewModelBuilder,rootPersonViewModelBuilder,treePersonViewModelBuilder,rawDisplayData,rawDataInflator}){
_.ensureInstanceOf('function',rootPersonViewModelBuilder);
_.ensureInstanceOf('function',treePersonViewModelBuilder);
_.ensureInstanceOf('object',rawDisplayData);
_.ensureInstanceOf('function',rawDataInflator,{nullable:!0});

const organizationDefaultSettings=await this._organizationDefaultsService.getFullOrganizationDefaults();

if(_.exists(rawDataInflator)){
rawDisplayData.estimatesAsOfTime=SocketResponse.safeDeserializeDate(rawDisplayData.estimatesAsOfTime);
rawDisplayData=rawDataInflator(rawDisplayData);
}

const aggregatePersonViewModelsForOrg=rawDisplayData.persons.map(personStats=>rootPersonViewModelBuilder(personStats));

const groupsViewModels=_constructViewModelTree(
groupViewModelBuilder,
treePersonViewModelBuilder,
rawDisplayData.groups,
EntityDictionary.create(aggregatePersonViewModelsForOrg),
organizationDefaultSettings);

const personsAssignedToAGroup=_(groupsViewModels).map('aggregatePersons').flatten().keyBy(p=>p.id).value();
const personsNotAssignedToAnyGroup=aggregatePersonViewModelsForOrg.filter(person=>!_.exists(personsAssignedToAGroup[person.id]));

const aggregateOrgStats=rawDisplayData.aggregateOrgStats||{};

const specialOrganizationGroupViewModel=groupViewModelBuilder(
null,
'Organization',
aggregatePersonViewModelsForOrg,
personsNotAssignedToAnyGroup,
aggregateOrgStats.numTripsOnDuty,
aggregateOrgStats.numPersonsOnDuty,
aggregateOrgStats.maxFatigueOnDuty,
aggregateOrgStats.maxLastKnownFatigue,
aggregateOrgStats.averageHoursOfSleepPerDay,
aggregateOrgStats.averageFatigueOnDuty,
organizationDefaultSettings.fatigueThreshold,
organizationDefaultSettings.deviationThreshold,void 0,!0);



_bringUpGroupMembershipsFromChilden(specialOrganizationGroupViewModel,groupsViewModels);
for(const notAssignedPerson of personsNotAssignedToAnyGroup){
notAssignedPerson.groupMembershipsAtScope.push(specialOrganizationGroupViewModel);
}

return{
groupTree:[specialOrganizationGroupViewModel].concat(groupsViewModels),
estimatesAsOfTime:rawDisplayData.estimatesAsOfTime,
hideAllGroupsByDefault:organizationDefaultSettings.hideAllGroupsByDefault};

}

_getViewScheduleFunc({id,employeeId,interval,timezone}){
_.ensureInstanceOf('string',id);
_.ensureInstanceOf('string',employeeId);
_.ensureInstanceOf(TimeInterval,interval);
_.ensureInstanceOf('string',timezone);
return({asString=!1,uiSref=!1,time=null}={})=>{
if(time){
interval=TimeInterval.fromPoint(time).shift('days',3,timezone);
}

return!asString&&!uiSref?
this._$state.go('fdc.features.personalSchedule',{id,interval,timezone,employeeId}):
uiSref?
`fdc.features.personalSchedule({ id: "${id}", interval: "${interval.start.toISOString()}-to-${interval.end.toISOString()}", timezone: "${timezone}", employeeId: "${employeeId}" })`:
`/#/personalSchedule?id=${id}`+
`&employeeId=${encodeURIComponent(employeeId)}`+
`&interval=${encodeURIComponent(`${interval.start.toISOString()}-to-${interval.end.toISOString()}`)}`+
`&timezone=${encodeURIComponent(timezone)}`;
};
}

_createIncidentViewModelsFor(personStats,incidentTypesByCode){
if(personStats.incidents.length===0){
return[];
}

const timezone=personStats.timezone;
const numIncidents=personStats.incidents.length;
const incidentViewModels=new Array(numIncidents);

for(let i=0;i<numIncidents;i++){
const rawIncident=personStats.incidents[i];
const viewScheduleFunc=this._getViewScheduleFunc({
id:personStats.id,
employeeId:personStats.employeeId,
interval:TimeInterval.fromPoint(rawIncident.time),
timezone});


incidentViewModels[i]=IncidentViewModel.createFrom(
rawIncident,
incidentTypesByCode[rawIncident.code],
timezone,
viewScheduleFunc);
}

return incidentViewModels;
}};


function _constructViewModelTree(groupViewModelBuilder,treePersonViewModelBuilder,rawGroupTree,orgPersonViewModelsById,defaultThresholds){
const viewModelTree=treeUtils.map(rawGroupTree,group=>{
const effectiveGroupFatigueThreshold=ex(group.fatigueThreshold).otherwise(defaultThresholds.fatigueThreshold);
const effectiveGroupDeviationThreshold=ex(group.deviationThreshold).otherwise(defaultThresholds.deviationThreshold);

const directPersonViewModels=_constructPersonViewModelsForTree(treePersonViewModelBuilder,group.directlyAssignedPersonIds,orgPersonViewModelsById);
const directPersonViewModelsById=_.keyBy(directPersonViewModels,'id');

const aggregatePersonViewModels=_constructPersonViewModelsForTree(treePersonViewModelBuilder,group.aggregatedPersonIds,orgPersonViewModelsById,directPersonViewModelsById);

const groupViewModel=groupViewModelBuilder(

group.id,
group.name,
aggregatePersonViewModels,
directPersonViewModels,
group.numTripsOnDuty,
group.numPersonsOnDuty,
group.maxFatigueOnDuty,
group.maxLastKnownFatigue,
group.averageHoursOfSleepPerDay,
group.averageFatigueOnDuty,
effectiveGroupFatigueThreshold,
effectiveGroupDeviationThreshold);


for(const directPersonViewModel of directPersonViewModels){
directPersonViewModel.groupMembershipsAtScope.push(groupViewModel);
}

return groupViewModel;
});


const reverseTraversableTree=[...treeUtils.flatten(viewModelTree)].reverse();
for(const groupViewModel of reverseTraversableTree){
_bringUpGroupMembershipsFromChilden(groupViewModel,groupViewModel.children);
}
return viewModelTree;
}

function _bringUpGroupMembershipsFromChilden(groupViewModel,children){
const unprocessedAggregatesById=_.keyBy(groupViewModel.aggregatePersons,p=>p.id);
for(const child of children){
for(const aggregatePerson of child.aggregatePersons){
_.pushMany(unprocessedAggregatesById[aggregatePerson.id].groupMembershipsAtScope,aggregatePerson.groupMembershipsAtScope);
}
}
}

function _constructPersonViewModelsForTree(treePersonViewModelBuilder,personIds,orgPersonViewModelsById,directPersonViewModelsById=null){
return personIds.map(personId=>orgPersonViewModelsById[personId]).
filter(orgPersonViewModel=>_.exists(orgPersonViewModel)).
map(orgPersonViewModel=>{
const directPersonViewModel=_.exists(directPersonViewModelsById)?directPersonViewModelsById[orgPersonViewModel.id]:null;
return ex(directPersonViewModel).otherwise(treePersonViewModelBuilder(orgPersonViewModel));
});
}






function _updateFatigueDistributionMetaData(fatigueDistribution,personViewModel){
for(const bin of fatigueDistribution.bins){
for(const item of bin){
item.metaData.person=personViewModel;
}
}
}

const _inflateSchedule=uninflatedSchedule=>{
_inflateInPlace(uninflatedSchedule,'bounds',b=>new TimeInterval(b));
_inflateInPlaceArray(uninflatedSchedule,'duties',d=>new DutyViewModel(d));
_inflateInPlaceArray(uninflatedSchedule,'trips',t=>new TripViewModel(t));
_inflateInPlaceArray(uninflatedSchedule,'flights',f=>new FlightViewModel(f));
_inflateInPlaceArray(uninflatedSchedule,'sleepPromotingIntervals',s=>new TimeInterval(s));
_inflateInPlaceArray(uninflatedSchedule,'sleep',s=>new TimeInterval(s));
};

function _inflateInPlace(obj,subPath,inflator){
const original=_.get(obj,subPath);

if(!_.exists(original)){
return;
}

_.set(obj,subPath,inflator(original));
}

function _inflateInPlaceArray(obj,subPath,inflator){
const original=_.get(obj,subPath,[]);

if(!_.exists(original)||original.length===0){
return;
}

_.set(obj,subPath,original.map(inflator));
}

module.exports=StatisticalDisplayDataService;
//# sourceMappingURL=statisticalDisplayDataService.js.map
